import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  getManagedCategories,
  getManagedContext
} from 'services/managed-blocking.service';

export const fetchManagedBootstrap = createAsyncThunk(
  'managedBlocking/bootstrap',
  async () => {
    const [context, registry] = await Promise.all([
      getManagedContext(),
      getManagedCategories()
    ]);
    return { context, registry };
  }
);
